import { refreshPage } from "../index";

// Calculate height of accordion hidden content
export function accordionHeight() {
  if (document.querySelector(".c-accordion-item")) {
    document
      .querySelectorAll(".c-accordion-content")
      .forEach(function (element) {
        var wysiwygHeight = element.offsetHeight;
        var hiddenContent = element.closest(".c-accordion-hidden");
        hiddenContent.style.height = wysiwygHeight + "px";
      });
  }
}

// Toggle accordion items open/closed
export function accordionToggle() {
  if (document.querySelectorAll(".c-accordion-item").length) {
    document.querySelectorAll(".c-accordion-click").forEach(function (item) {
      item.addEventListener("click", function () {
        const accordionItem = this.closest(".c-accordion-item");

        if (accordionItem) {
          accordionItem.classList.toggle("closed");

          accordionItem.parentElement
            .querySelectorAll(".c-accordion-item")
            .forEach(function (sibling) {
              if (sibling !== accordionItem) {
                sibling.classList.add("closed");
              }
            });

          refreshPage();
        }
      });
    });
  }
}
